import styled from 'styled-components';
import Colors from 'assets/Colors.js';

const NoColorContainer = styled.div`
  border: 1px solid ${Colors.background_dividers};
  box-sizing: border-box;
  border-radius: 5px;
  background: ${Colors.background_secondary};
  width: 20.28px;
  height: 20.67px;
  overflow: hidden;
  margin-right: 8.52px;
  cursor: pointer;
`;

const ColorContainer = styled.div`
  box-sizing: border-box;
  border-radius: 5px;
  background: ${(props) => props.color};
  width: 20.28px;
  height: 20.67px;
  margin-right: 8.52px;
  cursor: pointer;
`;

const ColorsContainer = styled.div`
  display: flex;
`;

export default {
  NoColorContainer,
  ColorContainer,
  ColorsContainer,
};
